import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import loadUserData from "../API/loadUserData";
import { GetGlobalColor } from "../utils/globalColors";
import { formatNumberForLocale } from "../utils/locale";

const EndGame = () => {
    const [balance, setBalance] = useState(0);
    const navigate = useNavigate();
    const color = GetGlobalColor();

    useEffect(() => {
        const token = localStorage.getItem("userToken");
        const gameId = localStorage.getItem("gameId");
        loadUserData(token, gameId, setBalance);
    }, []);

    return (
        <div className={`app-bg-${color} bg-overwrite` }>
            <div className="flex flex-col items-center justify-center text-center h-[400px] mt-40">
                <p className="wtext text-7xl  mb-20 blink">KONEC IGRE</p>
                <p className="wtext text-3xl mb-5">Končno Stanje: </p>
                <p className="wtext text-5xl ">{formatNumberForLocale(balance)}€</p>
                <button  onClick={() => navigate(`/`)} className="mt-[150px]">DOMOV</button> 
            </div>
        </div>
    );
};

export default EndGame;
